export enum DesktopAudioRecorderFailureReason {
  DesktopRecorderStartFailed = "desktop-recorder-start-failed",
  NetworkUnavailable = "network-unavailable",
}

export type SystemAudioRecordingFailedContext = {
  reason: DesktopAudioRecorderFailureReason;
};
